import Pinlogin from 'pinlogin';
import hook from '../../scripts/utilities/hook';

const PIN_INPUT_SELECTOR = hook('js-pin-input');

class PIN_INPUT {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }
    this.element = element;

    this.initPinLogin();
    this.initSelectors();
    this.SetValidetta();
  }

  initSelectors() {
    this.inputs = this.element.querySelectorAll('input');
  }

  SetValidetta() {
    this.inputs.forEach(input => {
      input.setAttribute('data-validetta', 'required');
    });
  }

  initPinLogin() {
    // eslint-disable-next-line no-unused-vars
    const pinlogin = new Pinlogin(this.element, {
      fields: 4,
      hideinput: false,
      reset: false,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(PIN_INPUT_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new PIN_INPUT(element);
  });
});
